import { ButtonDropdownMultiple, NavItem } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { useBankMatchesToolbarFilters } from '../../context/BankMatchesToolbarFiltersContext'
import { BankMatchesType } from '../../enums/bankMatchesType'
import { getSelectedTransactionTypes } from '../../utils/getSelectedTransactionTypes'

export const BankMatchesTypesSelector = (): ReactElement => {
  const { t } = useTranslation()
  const { queryParams, setQueryParams } = useBankMatchesToolbarFilters()
  const { track } = useSegment()

  const selectedValues = useMemo(
    () => getSelectedTransactionTypes(queryParams.transactionType),
    [queryParams.transactionType],
  )

  const items: NavItem<BankMatchesType>[] = useMemo(
    () => [
      {
        id: BankMatchesType.Positive,
        children: t('bank_integration.toolbar.type_filter.positive'),
        value: BankMatchesType.Positive,
      },
      {
        id: BankMatchesType.Negative,
        children: t('bank_integration.toolbar.type_filter.negative'),
        value: BankMatchesType.Negative,
      },
    ],
    [t],
  )

  const handleSelect = useCallback(
    (event: ChangeEvent<HTMLInputElement>, values: BankMatchesType[]) => {
      const hasPositive = values.includes(BankMatchesType.Positive)
      const hasNegative = values.includes(BankMatchesType.Negative)

      const transactionType = hasPositive && hasNegative ? undefined : values[0]

      setQueryParams({ transactionType })

      track('XXX - Reconciliation Filter Applied (Client)', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        filter_type: transactionType ? `${transactionType}_transactions` : 'all_transactions',
      })
    },
    [setQueryParams, track],
  )

  return (
    <ButtonDropdownMultiple
      items={items}
      onSelect={handleSelect}
      selectedValues={selectedValues}
      placement="bottom-start"
      selectAllText={t('bank_integration.toolbar.type_filter.all')}
      withSelectAll
    />
  )
}
